import { gql } from '@apollo/client/core';

export default gql`
  query OgCoreDataDialog {
    getTaxonomyCoreData {
      _id
      turnover
      turnoverFile {
        _id
        file {
          _id
          filename
          downloadUrl
        }
      }
      turnoverCompleteLater
      capEx
      capExFile {
        _id
        file {
          _id
          filename
          downloadUrl
        }
      }
      capExCompleteLater
      opEx
      opExFile {
        _id
        file {
          _id
          filename
          downloadUrl
        }
      }
      opExCompleteLater
      minimumSafeguards
    }
  }
`;
